import React, { useState, useEffect, useRef, createContext } from "react";

const ActionContext = createContext();

export const ActionConsumer = ActionContext.Consumer;

const ActionProvider = (props) => {
  const [action, setAction] = useState([]);

  return (
    <ActionContext.Provider
      value={{
        action,
        setAction,
      }}
    >
      {props.children}
    </ActionContext.Provider>
  );
};

export default ActionContext;

export { ActionProvider, ActionContext };
